<template>
  <div class="tabDiv d-flex py-5">
    <div v-for="(item, i) in items" :key="i">
      <v-btn
        class="text-none px-7 py-7 mr-2"
        :class="{
          active__class: i == selectedTab,
          inactive__class: i !== selectedTab,
        }"
        :color="i == selectedTab ? '#2d8cff' : '#EAEDF0'"
        @click="selectedTab = i"
      >
        <span>{{ item.title }}</span>
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: "TabComponent",
  props: {
    value: {
      type: String,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  computed: {
    selectedTabValue() {
      return this.items[this.selectedTab].value;
    },
  },
  watch: {
    selectedTab() {
      this.tabChanges();
    },
  },
  methods: {
    tabChanges() {
      this.$emit("input", this.selectedTabValue);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.tabDiv{
  width: 100%;
  overflow-x: scroll;
}
.active__class {
}
.active__class >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #ffffff;
}
.inactive__class >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #484747;
}
</style>
